// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~views/colors.css\"","easilBlack":"#2c2e2f","toolTip":"style_toolTip__1fXBU"};